import React from 'react';
import styled from 'styled-components';
import { IAppBarProps } from './AppBar.models';
import { StyledAppBar } from './AppBar.styles';
import { Brand } from './Brand';
import { Navigation } from './Navigation';
import { BrandSmall } from './BrandSmall';
import { Profile } from './Profile';
import { NavigationSmall } from './NavigationSmall';
import { AppBarActions } from './AppBarActions';

export const AppBar = styled((props: IAppBarProps) => {
  const navItems = props.navItems.filter((navItem) => !navItem.hide);
  return (
    <header className={props.className}>
      <div className="top">
        <Brand subTitle={props.appBarSubTitle} onAppBarSubTitleClick={props.onAppBarSubTitleClick} />
        <BrandSmall title={props.appBarTitle} />
        <Navigation navItems={navItems} activeItem={props.activeItem} onNavItemClick={props.onNavItemClick} />
        {props.appBarActionsContainer && <AppBarActions>{props.appBarActionsContainer}</AppBarActions>}
        <Profile
          subTitle={props.appBarTitle}
          userFullName={props.userFullName}
          profileMenuItems={props.profileMenuItems}
          onProfileMenuItemClick={props.onProfileMenuItemClick}
        />
      </div>
      <div className="bottom">
        <NavigationSmall navItems={navItems} activeItem={props.activeItem} onNavItemClick={props.onNavItemClick} />
      </div>
      <div className="gap"></div>
    </header>
  );
})`
  ${StyledAppBar}
`;
